<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M6.43196,2C6.52583,2.14046,6.63408,2.2725,6.75579,2.39421C6.75579,2.39421,8.42012,4,8.42012,4C8.42012,4,3.66,4,3.66,4C3.66,4,1.95,8,1.95,8C1.95,8,4,8,4,8C4.55,8,5,8.45,5,9C5,9,5,10,5,10C5,10,10.1788,10,10.1788,10C10.1788,10,11.5574,10,11.5574,10C12.2502,10,12.9202,9.73827,13.3942,9.26421C13.3942,9.26421,13.4968,9.16164,13.4968,9.16164C13.4968,9.16164,14.3466,8.02167,14.3466,8.02167C14.7479,7.55592,14.97,6.96544,14.97,6.34C14.97,6.34,14.97,5.05832,14.97,5.05832C14.97,5.05832,16,7.46,16,7.46C16,7.46,16,13,16,13C16,13.55,15.55,14,15,14C15,14,1,14,1,14C0.45,14,0,13.55,0,13C0,13,0,7.46,0,7.46C0,7.46,2.08,2.61,2.08,2.61C2.23,2.25,2.59,2,3,2C3,2,6.43196,2,6.43196,2C6.43196,2,6.43196,2,6.43196,2ZM15.48,0C15.79,0,16,0.26,16,0.57C16,0.73,15.94,0.87,15.83,0.98C15.83,0.98,12.97,3.71,12.97,3.71C12.97,3.71,12.97,6.34,12.97,6.34C12.97,6.5,12.91,6.64,12.8,6.75C12.8,6.75,11.98,7.85,11.98,7.85C11.88,7.95,11.73,8.02,11.57,8.02C11.26,8.02,11,7.76,11,7.45C11,7.45,11,3.71,11,3.71C11,3.71,8.17,0.98,8.17,0.98C8.06,0.87,8,0.73,8,0.57C8,0.26,8.26,0,8.57,0C8.57,0,15.48,0,15.48,0C15.48,0,15.48,0,15.48,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'InboxFiltered',
} as DefineComponent
</script>
